//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    adminLogin(body: AdminLoginCommandRequest | undefined): Promise<AdminLoginCommandResponse>;
    /**
     * @return Success
     */
    getAdminDashboard(): Promise<DashboardCommandResponse>;
    /**
     * @return Success
     */
    getStatisticsForAdminDashboard(): Promise<GetStatisticsCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPlayersByFilter(body: GetAllPlayersByFilterCommandRequest | undefined): Promise<GetAllPlayersByFilterCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAdminsByFilter(body: GetAllAdminsByFilterCommandRequest | undefined): Promise<GetAllAdminsByFilterCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getEventPoints(body: GetPointsCommandRequest | undefined): Promise<GetPointsCommandResponse>;
    /**
     * @return Success
     */
    getAllRoles(): Promise<GetAllRolesByFilterCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addAdminUser(body: AddAdminUserCommandRequest | undefined): Promise<AddAdminUserCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPlayerGamesByUserId(body: GetPlayerGamesByUserIdAndFilterCommandRequest | undefined): Promise<GetPlayerGamesByUserIdAndFilterCommandResponse>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getPlayerGameDetailsByGameId(id: string | undefined): Promise<GetPlayerGameDetailsByGameIdCommandResponse>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getPlayerByUserId(id: string | undefined): Promise<GetPlayerByUserIdCommandResponse>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getPlayerDetailsByUserId(id: string | undefined): Promise<GetPlayerDetailsByUserIdCommandResponse>;
    /**
     * @return Success
     */
    getUserCount(): Promise<DashboardQueryOnlineUsersResponse>;
    /**
     * @param period (optional) 
     * @return Success
     */
    getGameHistory(period: string | undefined): Promise<GetGameHistoryCommandResponse>;
    /**
     * @param period (optional) 
     * @return Success
     */
    getTopPerformers(period: string | undefined): Promise<GetTopPerformersCommandResponse>;
    /**
     * @return Success
     */
    logout(): Promise<void>;
    /**
     * @return Success
     */
    products(): Promise<void>;
    /**
     * @return Success
     */
    milestones(): Promise<void>;
    /**
     * @return Success
     */
    specialPromotions(): Promise<void>;
    /**
     * @return Success
     */
    files(): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateProducts(body: UpdateTranslationDto | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateMilestones(body: UpdateTranslationDto | undefined): Promise<void>;
    /**
     * @param locale (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateSpecialpromotions(locale: string | undefined, body: SpecialPromotionDto | undefined): Promise<void>;
    /**
     * @param id (optional) 
     * @param locale (optional) 
     * @return Success
     */
    getProducts(id: string | undefined, locale: string | undefined): Promise<void>;
    /**
     * @param id (optional) 
     * @param locale (optional) 
     * @return Success
     */
    getMilestones(id: string | undefined, locale: string | undefined): Promise<void>;
    /**
     * @param id (optional) 
     * @param locale (optional) 
     * @return Success
     */
    getSpecialpromotions(id: string | undefined, locale: string | undefined): Promise<void>;
}

export class Client implements IClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    adminLogin(body: AdminLoginCommandRequest | undefined, cancelToken?: CancelToken): Promise<AdminLoginCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/AdminLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdminLogin(_response);
        });
    }

    protected processAdminLogin(response: AxiosResponse): Promise<AdminLoginCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdminLoginCommandResponse.fromJS(resultData200);
            return Promise.resolve<AdminLoginCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminLoginCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAdminDashboard( cancelToken?: CancelToken): Promise<DashboardCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetAdminDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminDashboard(_response);
        });
    }

    protected processGetAdminDashboard(response: AxiosResponse): Promise<DashboardCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DashboardCommandResponse.fromJS(resultData200);
            return Promise.resolve<DashboardCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getStatisticsForAdminDashboard( cancelToken?: CancelToken): Promise<GetStatisticsCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetStatisticsForAdminDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatisticsForAdminDashboard(_response);
        });
    }

    protected processGetStatisticsForAdminDashboard(response: AxiosResponse): Promise<GetStatisticsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetStatisticsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetStatisticsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetStatisticsCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPlayersByFilter(body: GetAllPlayersByFilterCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetAllPlayersByFilterCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetPlayersByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlayersByFilter(_response);
        });
    }

    protected processGetPlayersByFilter(response: AxiosResponse): Promise<GetAllPlayersByFilterCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllPlayersByFilterCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetAllPlayersByFilterCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllPlayersByFilterCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAdminsByFilter(body: GetAllAdminsByFilterCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetAllAdminsByFilterCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetAdminsByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminsByFilter(_response);
        });
    }

    protected processGetAdminsByFilter(response: AxiosResponse): Promise<GetAllAdminsByFilterCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllAdminsByFilterCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetAllAdminsByFilterCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllAdminsByFilterCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEventPoints(body: GetPointsCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetPointsCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetEventPoints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEventPoints(_response);
        });
    }

    protected processGetEventPoints(response: AxiosResponse): Promise<GetPointsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPointsCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPointsCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPointsCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllRoles( cancelToken?: CancelToken): Promise<GetAllRolesByFilterCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetAllRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllRoles(_response);
        });
    }

    protected processGetAllRoles(response: AxiosResponse): Promise<GetAllRolesByFilterCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllRolesByFilterCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetAllRolesByFilterCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllRolesByFilterCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addAdminUser(body: AddAdminUserCommandRequest | undefined, cancelToken?: CancelToken): Promise<AddAdminUserCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/AddAdminUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAdminUser(_response);
        });
    }

    protected processAddAdminUser(response: AxiosResponse): Promise<AddAdminUserCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddAdminUserCommandResponse.fromJS(resultData200);
            return Promise.resolve<AddAdminUserCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddAdminUserCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPlayerGamesByUserId(body: GetPlayerGamesByUserIdAndFilterCommandRequest | undefined, cancelToken?: CancelToken): Promise<GetPlayerGamesByUserIdAndFilterCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetPlayerGamesByUserId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlayerGamesByUserId(_response);
        });
    }

    protected processGetPlayerGamesByUserId(response: AxiosResponse): Promise<GetPlayerGamesByUserIdAndFilterCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayerGamesByUserIdAndFilterCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayerGamesByUserIdAndFilterCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayerGamesByUserIdAndFilterCommandResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlayerGameDetailsByGameId(id: string | undefined, cancelToken?: CancelToken): Promise<GetPlayerGameDetailsByGameIdCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetPlayerGameDetailsByGameId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlayerGameDetailsByGameId(_response);
        });
    }

    protected processGetPlayerGameDetailsByGameId(response: AxiosResponse): Promise<GetPlayerGameDetailsByGameIdCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayerGameDetailsByGameIdCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayerGameDetailsByGameIdCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayerGameDetailsByGameIdCommandResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlayerByUserId(id: string | undefined, cancelToken?: CancelToken): Promise<GetPlayerByUserIdCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetPlayerByUserId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlayerByUserId(_response);
        });
    }

    protected processGetPlayerByUserId(response: AxiosResponse): Promise<GetPlayerByUserIdCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayerByUserIdCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayerByUserIdCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayerByUserIdCommandResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlayerDetailsByUserId(id: string | undefined, cancelToken?: CancelToken): Promise<GetPlayerDetailsByUserIdCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetPlayerDetailsByUserId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlayerDetailsByUserId(_response);
        });
    }

    protected processGetPlayerDetailsByUserId(response: AxiosResponse): Promise<GetPlayerDetailsByUserIdCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPlayerDetailsByUserIdCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetPlayerDetailsByUserIdCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPlayerDetailsByUserIdCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserCount( cancelToken?: CancelToken): Promise<DashboardQueryOnlineUsersResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetUserCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserCount(_response);
        });
    }

    protected processGetUserCount(response: AxiosResponse): Promise<DashboardQueryOnlineUsersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DashboardQueryOnlineUsersResponse.fromJS(resultData200);
            return Promise.resolve<DashboardQueryOnlineUsersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardQueryOnlineUsersResponse>(null as any);
    }

    /**
     * @param period (optional) 
     * @return Success
     */
    getGameHistory(period: string | undefined, cancelToken?: CancelToken): Promise<GetGameHistoryCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetGameHistory?";
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGameHistory(_response);
        });
    }

    protected processGetGameHistory(response: AxiosResponse): Promise<GetGameHistoryCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetGameHistoryCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetGameHistoryCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGameHistoryCommandResponse>(null as any);
    }

    /**
     * @param period (optional) 
     * @return Success
     */
    getTopPerformers(period: string | undefined, cancelToken?: CancelToken): Promise<GetTopPerformersCommandResponse> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/commands/GetTopPerformers?";
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopPerformers(_response);
        });
    }

    protected processGetTopPerformers(response: AxiosResponse): Promise<GetTopPerformersCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTopPerformersCommandResponse.fromJS(resultData200);
            return Promise.resolve<GetTopPerformersCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTopPerformersCommandResponse>(null as any);
    }

    /**
     * @return Success
     */
    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Security/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    products( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Translate/Products";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProducts(_response);
        });
    }

    protected processProducts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    milestones( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Translate/Milestones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMilestones(_response);
        });
    }

    protected processMilestones(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    specialPromotions( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Translate/SpecialPromotions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSpecialPromotions(_response);
        });
    }

    protected processSpecialPromotions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    files( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Translate/Files";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFiles(_response);
        });
    }

    protected processFiles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProducts(body: UpdateTranslationDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/translate/update-products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProducts(_response);
        });
    }

    protected processUpdateProducts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMilestones(body: UpdateTranslationDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/translate/update-milestones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMilestones(_response);
        });
    }

    protected processUpdateMilestones(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param locale (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateSpecialpromotions(locale: string | undefined, body: SpecialPromotionDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/translate/update-specialpromotions?";
        if (locale === null)
            throw new Error("The parameter 'locale' cannot be null.");
        else if (locale !== undefined)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSpecialpromotions(_response);
        });
    }

    protected processUpdateSpecialpromotions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param locale (optional) 
     * @return Success
     */
    getProducts(id: string | undefined, locale: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/translate/get-products?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (locale === null)
            throw new Error("The parameter 'locale' cannot be null.");
        else if (locale !== undefined)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProducts(_response);
        });
    }

    protected processGetProducts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param locale (optional) 
     * @return Success
     */
    getMilestones(id: string | undefined, locale: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/translate/get-milestones?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (locale === null)
            throw new Error("The parameter 'locale' cannot be null.");
        else if (locale !== undefined)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMilestones(_response);
        });
    }

    protected processGetMilestones(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param locale (optional) 
     * @return Success
     */
    getSpecialpromotions(id: string | undefined, locale: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/sa/sudokuvs/admin/translate/get-specialpromotions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (locale === null)
            throw new Error("The parameter 'locale' cannot be null.");
        else if (locale !== undefined)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpecialpromotions(_response);
        });
    }

    protected processGetSpecialpromotions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AdminLoginCommandRequest implements IAdminLoginCommandRequest {
    username?: string | undefined;
    fcmToken?: string | undefined;
    password?: string | undefined;
    locale?: string | undefined;

    constructor(data?: IAdminLoginCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.fcmToken = _data["fcmToken"];
            this.password = _data["password"];
            this.locale = _data["locale"];
        }
    }

    static fromJS(data: any): AdminLoginCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdminLoginCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["fcmToken"] = this.fcmToken;
        data["password"] = this.password;
        data["locale"] = this.locale;
        return data;
    }

    clone(): AdminLoginCommandRequest {
        const json = this.toJSON();
        let result = new AdminLoginCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAdminLoginCommandRequest {
    username?: string | undefined;
    fcmToken?: string | undefined;
    password?: string | undefined;
    locale?: string | undefined;
}

export enum UserStatus {
    Disabled = "Disabled",
    Active = "Active",
    Locked = "locked",
    UnderReview = "UnderReview",
    Flagged = "Flagged",
    BotDisabled = "BotDisabled",
    BotActive = "BotActive",
    Deleted = "Deleted",
}

export class AdminLoginCommandResponse implements IAdminLoginCommandResponse {
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loggedIn?: boolean;
    userId?: string | undefined;
    status?: UserStatus;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
    forcePasswordChange?: boolean;
    emailConfirmed?: boolean;
    sessionId?: string | undefined;
    roles?: string[] | undefined;
    roleIds?: string[] | undefined;
    operations?: string[] | undefined;

    constructor(data?: IAdminLoginCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.loggedIn = _data["loggedIn"];
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            this.accessToken = _data["accessToken"];
            this.forcePasswordChange = _data["forcePasswordChange"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.sessionId = _data["sessionId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
        }
    }

    static fromJS(data: any): AdminLoginCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdminLoginCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["loggedIn"] = this.loggedIn;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["accessToken"] = this.accessToken;
        data["forcePasswordChange"] = this.forcePasswordChange;
        data["emailConfirmed"] = this.emailConfirmed;
        data["sessionId"] = this.sessionId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        return data;
    }

    clone(): AdminLoginCommandResponse {
        const json = this.toJSON();
        let result = new AdminLoginCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAdminLoginCommandResponse {
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loggedIn?: boolean;
    userId?: string | undefined;
    status?: UserStatus;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
    forcePasswordChange?: boolean;
    emailConfirmed?: boolean;
    sessionId?: string | undefined;
    roles?: string[] | undefined;
    roleIds?: string[] | undefined;
    operations?: string[] | undefined;
}

export class DashboardCard implements IDashboardCard {
    title?: string | undefined;
    subTitle?: string | undefined;
    count?: number;
    displayText?: string | undefined;

    constructor(data?: IDashboardCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.count = _data["count"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): DashboardCard {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["count"] = this.count;
        data["displayText"] = this.displayText;
        return data;
    }

    clone(): DashboardCard {
        const json = this.toJSON();
        let result = new DashboardCard();
        result.init(json);
        return result;
    }
}

export interface IDashboardCard {
    title?: string | undefined;
    subTitle?: string | undefined;
    count?: number;
    displayText?: string | undefined;
}

export enum PlayerRank {
    Beginner = "Beginner",
    Apprentice = "Apprentice",
    Professional = "Professional",
    Expert = "Expert",
    Master = "Master",
    GrandMaster = "GrandMaster",
}

export class VersusLeaderboardView implements IVersusLeaderboardView {
    userName?: string | undefined;
    position?: number;
    userId?: string;
    rank?: PlayerRank | undefined;
    countryCode?: string | undefined;
    icon?: number | undefined;
    rating?: number | undefined;
    wins?: number | undefined;
    losses?: number | undefined;
    recordWinsAndLosses?: string | undefined;

    constructor(data?: IVersusLeaderboardView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.position = _data["position"];
            this.userId = _data["userId"];
            this.rank = _data["rank"];
            this.countryCode = _data["countryCode"];
            this.icon = _data["icon"];
            this.rating = _data["rating"];
            this.wins = _data["wins"];
            this.losses = _data["losses"];
            this.recordWinsAndLosses = _data["recordWinsAndLosses"];
        }
    }

    static fromJS(data: any): VersusLeaderboardView {
        data = typeof data === 'object' ? data : {};
        let result = new VersusLeaderboardView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["position"] = this.position;
        data["userId"] = this.userId;
        data["rank"] = this.rank;
        data["countryCode"] = this.countryCode;
        data["icon"] = this.icon;
        data["rating"] = this.rating;
        data["wins"] = this.wins;
        data["losses"] = this.losses;
        data["recordWinsAndLosses"] = this.recordWinsAndLosses;
        return data;
    }

    clone(): VersusLeaderboardView {
        const json = this.toJSON();
        let result = new VersusLeaderboardView();
        result.init(json);
        return result;
    }
}

export interface IVersusLeaderboardView {
    userName?: string | undefined;
    position?: number;
    userId?: string;
    rank?: PlayerRank | undefined;
    countryCode?: string | undefined;
    icon?: number | undefined;
    rating?: number | undefined;
    wins?: number | undefined;
    losses?: number | undefined;
    recordWinsAndLosses?: string | undefined;
}

export enum Difficulty {
    Easy = "Easy",
    Medium = "Medium",
    Hard = "Hard",
    Expert = "Expert",
    MediumHard = "MediumHard",
    EasyMedium = "EasyMedium",
    TremendouslyEasy = "TremendouslyEasy",
}

export class PracticeLeaderboardView implements IPracticeLeaderboardView {
    position?: number;
    userId?: string;
    userName?: string | undefined;
    countryCode?: string | undefined;
    icon?: number | undefined;
    rank?: PlayerRank;
    difficultyLevel?: Difficulty;
    bestTime?: string | undefined;

    constructor(data?: IPracticeLeaderboardView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.countryCode = _data["countryCode"];
            this.icon = _data["icon"];
            this.rank = _data["rank"];
            this.difficultyLevel = _data["difficultyLevel"];
            this.bestTime = _data["bestTime"];
        }
    }

    static fromJS(data: any): PracticeLeaderboardView {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeLeaderboardView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["countryCode"] = this.countryCode;
        data["icon"] = this.icon;
        data["rank"] = this.rank;
        data["difficultyLevel"] = this.difficultyLevel;
        data["bestTime"] = this.bestTime;
        return data;
    }

    clone(): PracticeLeaderboardView {
        const json = this.toJSON();
        let result = new PracticeLeaderboardView();
        result.init(json);
        return result;
    }
}

export interface IPracticeLeaderboardView {
    position?: number;
    userId?: string;
    userName?: string | undefined;
    countryCode?: string | undefined;
    icon?: number | undefined;
    rank?: PlayerRank;
    difficultyLevel?: Difficulty;
    bestTime?: string | undefined;
}

export class DashboardCommandResponse implements IDashboardCommandResponse {
    playerCards?: DashboardCard[] | undefined;
    gameCards?: DashboardCard[] | undefined;
    gameCompletedCards?: DashboardCard[] | undefined;
    topVSPlayers?: VersusLeaderboardView[] | undefined;
    topEasyModePlayers?: PracticeLeaderboardView[] | undefined;
    topMediumModePlayers?: PracticeLeaderboardView[] | undefined;
    topHardModePlayers?: PracticeLeaderboardView[] | undefined;
    topExpertModePlayers?: PracticeLeaderboardView[] | undefined;

    constructor(data?: IDashboardCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.playerCards) {
                this.playerCards = [];
                for (let i = 0; i < data.playerCards.length; i++) {
                    let item = data.playerCards[i];
                    this.playerCards[i] = item && !(<any>item).toJSON ? new DashboardCard(item) : <DashboardCard>item;
                }
            }
            if (data.gameCards) {
                this.gameCards = [];
                for (let i = 0; i < data.gameCards.length; i++) {
                    let item = data.gameCards[i];
                    this.gameCards[i] = item && !(<any>item).toJSON ? new DashboardCard(item) : <DashboardCard>item;
                }
            }
            if (data.gameCompletedCards) {
                this.gameCompletedCards = [];
                for (let i = 0; i < data.gameCompletedCards.length; i++) {
                    let item = data.gameCompletedCards[i];
                    this.gameCompletedCards[i] = item && !(<any>item).toJSON ? new DashboardCard(item) : <DashboardCard>item;
                }
            }
            if (data.topVSPlayers) {
                this.topVSPlayers = [];
                for (let i = 0; i < data.topVSPlayers.length; i++) {
                    let item = data.topVSPlayers[i];
                    this.topVSPlayers[i] = item && !(<any>item).toJSON ? new VersusLeaderboardView(item) : <VersusLeaderboardView>item;
                }
            }
            if (data.topEasyModePlayers) {
                this.topEasyModePlayers = [];
                for (let i = 0; i < data.topEasyModePlayers.length; i++) {
                    let item = data.topEasyModePlayers[i];
                    this.topEasyModePlayers[i] = item && !(<any>item).toJSON ? new PracticeLeaderboardView(item) : <PracticeLeaderboardView>item;
                }
            }
            if (data.topMediumModePlayers) {
                this.topMediumModePlayers = [];
                for (let i = 0; i < data.topMediumModePlayers.length; i++) {
                    let item = data.topMediumModePlayers[i];
                    this.topMediumModePlayers[i] = item && !(<any>item).toJSON ? new PracticeLeaderboardView(item) : <PracticeLeaderboardView>item;
                }
            }
            if (data.topHardModePlayers) {
                this.topHardModePlayers = [];
                for (let i = 0; i < data.topHardModePlayers.length; i++) {
                    let item = data.topHardModePlayers[i];
                    this.topHardModePlayers[i] = item && !(<any>item).toJSON ? new PracticeLeaderboardView(item) : <PracticeLeaderboardView>item;
                }
            }
            if (data.topExpertModePlayers) {
                this.topExpertModePlayers = [];
                for (let i = 0; i < data.topExpertModePlayers.length; i++) {
                    let item = data.topExpertModePlayers[i];
                    this.topExpertModePlayers[i] = item && !(<any>item).toJSON ? new PracticeLeaderboardView(item) : <PracticeLeaderboardView>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["playerCards"])) {
                this.playerCards = [] as any;
                for (let item of _data["playerCards"])
                    this.playerCards!.push(DashboardCard.fromJS(item));
            }
            if (Array.isArray(_data["gameCards"])) {
                this.gameCards = [] as any;
                for (let item of _data["gameCards"])
                    this.gameCards!.push(DashboardCard.fromJS(item));
            }
            if (Array.isArray(_data["gameCompletedCards"])) {
                this.gameCompletedCards = [] as any;
                for (let item of _data["gameCompletedCards"])
                    this.gameCompletedCards!.push(DashboardCard.fromJS(item));
            }
            if (Array.isArray(_data["topVSPlayers"])) {
                this.topVSPlayers = [] as any;
                for (let item of _data["topVSPlayers"])
                    this.topVSPlayers!.push(VersusLeaderboardView.fromJS(item));
            }
            if (Array.isArray(_data["topEasyModePlayers"])) {
                this.topEasyModePlayers = [] as any;
                for (let item of _data["topEasyModePlayers"])
                    this.topEasyModePlayers!.push(PracticeLeaderboardView.fromJS(item));
            }
            if (Array.isArray(_data["topMediumModePlayers"])) {
                this.topMediumModePlayers = [] as any;
                for (let item of _data["topMediumModePlayers"])
                    this.topMediumModePlayers!.push(PracticeLeaderboardView.fromJS(item));
            }
            if (Array.isArray(_data["topHardModePlayers"])) {
                this.topHardModePlayers = [] as any;
                for (let item of _data["topHardModePlayers"])
                    this.topHardModePlayers!.push(PracticeLeaderboardView.fromJS(item));
            }
            if (Array.isArray(_data["topExpertModePlayers"])) {
                this.topExpertModePlayers = [] as any;
                for (let item of _data["topExpertModePlayers"])
                    this.topExpertModePlayers!.push(PracticeLeaderboardView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.playerCards)) {
            data["playerCards"] = [];
            for (let item of this.playerCards)
                data["playerCards"].push(item.toJSON());
        }
        if (Array.isArray(this.gameCards)) {
            data["gameCards"] = [];
            for (let item of this.gameCards)
                data["gameCards"].push(item.toJSON());
        }
        if (Array.isArray(this.gameCompletedCards)) {
            data["gameCompletedCards"] = [];
            for (let item of this.gameCompletedCards)
                data["gameCompletedCards"].push(item.toJSON());
        }
        if (Array.isArray(this.topVSPlayers)) {
            data["topVSPlayers"] = [];
            for (let item of this.topVSPlayers)
                data["topVSPlayers"].push(item.toJSON());
        }
        if (Array.isArray(this.topEasyModePlayers)) {
            data["topEasyModePlayers"] = [];
            for (let item of this.topEasyModePlayers)
                data["topEasyModePlayers"].push(item.toJSON());
        }
        if (Array.isArray(this.topMediumModePlayers)) {
            data["topMediumModePlayers"] = [];
            for (let item of this.topMediumModePlayers)
                data["topMediumModePlayers"].push(item.toJSON());
        }
        if (Array.isArray(this.topHardModePlayers)) {
            data["topHardModePlayers"] = [];
            for (let item of this.topHardModePlayers)
                data["topHardModePlayers"].push(item.toJSON());
        }
        if (Array.isArray(this.topExpertModePlayers)) {
            data["topExpertModePlayers"] = [];
            for (let item of this.topExpertModePlayers)
                data["topExpertModePlayers"].push(item.toJSON());
        }
        return data;
    }

    clone(): DashboardCommandResponse {
        const json = this.toJSON();
        let result = new DashboardCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IDashboardCommandResponse {
    playerCards?: IDashboardCard[] | undefined;
    gameCards?: IDashboardCard[] | undefined;
    gameCompletedCards?: IDashboardCard[] | undefined;
    topVSPlayers?: IVersusLeaderboardView[] | undefined;
    topEasyModePlayers?: IPracticeLeaderboardView[] | undefined;
    topMediumModePlayers?: IPracticeLeaderboardView[] | undefined;
    topHardModePlayers?: IPracticeLeaderboardView[] | undefined;
    topExpertModePlayers?: IPracticeLeaderboardView[] | undefined;
}

export class UsageStats implements IUsageStats {
    current?: number;
    previous?: number;
    percentageChange?: number;

    constructor(data?: IUsageStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.current = _data["current"];
            this.previous = _data["previous"];
            this.percentageChange = _data["percentageChange"];
        }
    }

    static fromJS(data: any): UsageStats {
        data = typeof data === 'object' ? data : {};
        let result = new UsageStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["previous"] = this.previous;
        data["percentageChange"] = this.percentageChange;
        return data;
    }

    clone(): UsageStats {
        const json = this.toJSON();
        let result = new UsageStats();
        result.init(json);
        return result;
    }
}

export interface IUsageStats {
    current?: number;
    previous?: number;
    percentageChange?: number;
}

export class ChallengeStats implements IChallengeStats {
    completed?: number;
    failed?: number;
    completionRate?: number;

    constructor(data?: IChallengeStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completed = _data["completed"];
            this.failed = _data["failed"];
            this.completionRate = _data["completionRate"];
        }
    }

    static fromJS(data: any): ChallengeStats {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completed"] = this.completed;
        data["failed"] = this.failed;
        data["completionRate"] = this.completionRate;
        return data;
    }

    clone(): ChallengeStats {
        const json = this.toJSON();
        let result = new ChallengeStats();
        result.init(json);
        return result;
    }
}

export interface IChallengeStats {
    completed?: number;
    failed?: number;
    completionRate?: number;
}

export class GameStats implements IGameStats {
    started?: number;
    inProgress?: number;
    completed?: number;
    startedYesterday?: number;
    completedYesterday?: number;
    startedPercentageChange?: number;
    completedPercentageChange?: number;

    constructor(data?: IGameStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.started = _data["started"];
            this.inProgress = _data["inProgress"];
            this.completed = _data["completed"];
            this.startedYesterday = _data["startedYesterday"];
            this.completedYesterday = _data["completedYesterday"];
            this.startedPercentageChange = _data["startedPercentageChange"];
            this.completedPercentageChange = _data["completedPercentageChange"];
        }
    }

    static fromJS(data: any): GameStats {
        data = typeof data === 'object' ? data : {};
        let result = new GameStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["started"] = this.started;
        data["inProgress"] = this.inProgress;
        data["completed"] = this.completed;
        data["startedYesterday"] = this.startedYesterday;
        data["completedYesterday"] = this.completedYesterday;
        data["startedPercentageChange"] = this.startedPercentageChange;
        data["completedPercentageChange"] = this.completedPercentageChange;
        return data;
    }

    clone(): GameStats {
        const json = this.toJSON();
        let result = new GameStats();
        result.init(json);
        return result;
    }
}

export interface IGameStats {
    started?: number;
    inProgress?: number;
    completed?: number;
    startedYesterday?: number;
    completedYesterday?: number;
    startedPercentageChange?: number;
    completedPercentageChange?: number;
}

export class GetStatisticsCommandResponse implements IGetStatisticsCommandResponse {
    success?: boolean;
    dailyUsers?: UsageStats | undefined;
    weeklyUsers?: UsageStats | undefined;
    monthlyUsers?: UsageStats | undefined;
    quarterlyUsers?: UsageStats | undefined;
    dailyChallenge?: ChallengeStats | undefined;
    weeklyChallenge?: ChallengeStats | undefined;
    monthlyChallenge?: ChallengeStats | undefined;
    singleModeGames?: GameStats | undefined;
    vsGames?: GameStats | undefined;
    readonly singleModeGamesCompleted?: number;
    readonly singleModeGamesInProgress?: number;
    readonly vsGamesStarted?: number;
    readonly vsGamesInProgress?: number;
    readonly vsGamesCompleted?: number;

    constructor(data?: IGetStatisticsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.dailyUsers = data.dailyUsers && !(<any>data.dailyUsers).toJSON ? new UsageStats(data.dailyUsers) : <UsageStats>this.dailyUsers;
            this.weeklyUsers = data.weeklyUsers && !(<any>data.weeklyUsers).toJSON ? new UsageStats(data.weeklyUsers) : <UsageStats>this.weeklyUsers;
            this.monthlyUsers = data.monthlyUsers && !(<any>data.monthlyUsers).toJSON ? new UsageStats(data.monthlyUsers) : <UsageStats>this.monthlyUsers;
            this.quarterlyUsers = data.quarterlyUsers && !(<any>data.quarterlyUsers).toJSON ? new UsageStats(data.quarterlyUsers) : <UsageStats>this.quarterlyUsers;
            this.dailyChallenge = data.dailyChallenge && !(<any>data.dailyChallenge).toJSON ? new ChallengeStats(data.dailyChallenge) : <ChallengeStats>this.dailyChallenge;
            this.weeklyChallenge = data.weeklyChallenge && !(<any>data.weeklyChallenge).toJSON ? new ChallengeStats(data.weeklyChallenge) : <ChallengeStats>this.weeklyChallenge;
            this.monthlyChallenge = data.monthlyChallenge && !(<any>data.monthlyChallenge).toJSON ? new ChallengeStats(data.monthlyChallenge) : <ChallengeStats>this.monthlyChallenge;
            this.singleModeGames = data.singleModeGames && !(<any>data.singleModeGames).toJSON ? new GameStats(data.singleModeGames) : <GameStats>this.singleModeGames;
            this.vsGames = data.vsGames && !(<any>data.vsGames).toJSON ? new GameStats(data.vsGames) : <GameStats>this.vsGames;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.dailyUsers = _data["dailyUsers"] ? UsageStats.fromJS(_data["dailyUsers"]) : <any>undefined;
            this.weeklyUsers = _data["weeklyUsers"] ? UsageStats.fromJS(_data["weeklyUsers"]) : <any>undefined;
            this.monthlyUsers = _data["monthlyUsers"] ? UsageStats.fromJS(_data["monthlyUsers"]) : <any>undefined;
            this.quarterlyUsers = _data["quarterlyUsers"] ? UsageStats.fromJS(_data["quarterlyUsers"]) : <any>undefined;
            this.dailyChallenge = _data["dailyChallenge"] ? ChallengeStats.fromJS(_data["dailyChallenge"]) : <any>undefined;
            this.weeklyChallenge = _data["weeklyChallenge"] ? ChallengeStats.fromJS(_data["weeklyChallenge"]) : <any>undefined;
            this.monthlyChallenge = _data["monthlyChallenge"] ? ChallengeStats.fromJS(_data["monthlyChallenge"]) : <any>undefined;
            this.singleModeGames = _data["singleModeGames"] ? GameStats.fromJS(_data["singleModeGames"]) : <any>undefined;
            this.vsGames = _data["vsGames"] ? GameStats.fromJS(_data["vsGames"]) : <any>undefined;
            (<any>this).singleModeGamesCompleted = _data["singleModeGamesCompleted"];
            (<any>this).singleModeGamesInProgress = _data["singleModeGamesInProgress"];
            (<any>this).vsGamesStarted = _data["vsGamesStarted"];
            (<any>this).vsGamesInProgress = _data["vsGamesInProgress"];
            (<any>this).vsGamesCompleted = _data["vsGamesCompleted"];
        }
    }

    static fromJS(data: any): GetStatisticsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatisticsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["dailyUsers"] = this.dailyUsers ? this.dailyUsers.toJSON() : <any>undefined;
        data["weeklyUsers"] = this.weeklyUsers ? this.weeklyUsers.toJSON() : <any>undefined;
        data["monthlyUsers"] = this.monthlyUsers ? this.monthlyUsers.toJSON() : <any>undefined;
        data["quarterlyUsers"] = this.quarterlyUsers ? this.quarterlyUsers.toJSON() : <any>undefined;
        data["dailyChallenge"] = this.dailyChallenge ? this.dailyChallenge.toJSON() : <any>undefined;
        data["weeklyChallenge"] = this.weeklyChallenge ? this.weeklyChallenge.toJSON() : <any>undefined;
        data["monthlyChallenge"] = this.monthlyChallenge ? this.monthlyChallenge.toJSON() : <any>undefined;
        data["singleModeGames"] = this.singleModeGames ? this.singleModeGames.toJSON() : <any>undefined;
        data["vsGames"] = this.vsGames ? this.vsGames.toJSON() : <any>undefined;
        data["singleModeGamesCompleted"] = this.singleModeGamesCompleted;
        data["singleModeGamesInProgress"] = this.singleModeGamesInProgress;
        data["vsGamesStarted"] = this.vsGamesStarted;
        data["vsGamesInProgress"] = this.vsGamesInProgress;
        data["vsGamesCompleted"] = this.vsGamesCompleted;
        return data;
    }

    clone(): GetStatisticsCommandResponse {
        const json = this.toJSON();
        let result = new GetStatisticsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetStatisticsCommandResponse {
    success?: boolean;
    dailyUsers?: IUsageStats | undefined;
    weeklyUsers?: IUsageStats | undefined;
    monthlyUsers?: IUsageStats | undefined;
    quarterlyUsers?: IUsageStats | undefined;
    dailyChallenge?: IChallengeStats | undefined;
    weeklyChallenge?: IChallengeStats | undefined;
    monthlyChallenge?: IChallengeStats | undefined;
    singleModeGames?: IGameStats | undefined;
    vsGames?: IGameStats | undefined;
    singleModeGamesCompleted?: number;
    singleModeGamesInProgress?: number;
    vsGamesStarted?: number;
    vsGamesInProgress?: number;
    vsGamesCompleted?: number;
}

export enum FilterType {
    Contains = "Contains",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqualTo = "GreaterThanOrEqualTo",
    LessThan = "LessThan",
    LessThanOrEqualTo = "LessThanOrEqualTo",
    Equal = "Equal",
    Group = "Group",
}

export enum JoinType {
    And = "and",
    Or = "or",
}

export class Filter implements IFilter {
    field?: string | undefined;
    filterType?: FilterType;
    value?: string | undefined;
    joinType?: JoinType;
    groupFilters?: Filter[] | undefined;
    readonly isGroupFilter?: boolean;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.groupFilters) {
                this.groupFilters = [];
                for (let i = 0; i < data.groupFilters.length; i++) {
                    let item = data.groupFilters[i];
                    this.groupFilters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.filterType = _data["filterType"];
            this.value = _data["value"];
            this.joinType = _data["joinType"];
            if (Array.isArray(_data["groupFilters"])) {
                this.groupFilters = [] as any;
                for (let item of _data["groupFilters"])
                    this.groupFilters!.push(Filter.fromJS(item));
            }
            (<any>this).isGroupFilter = _data["isGroupFilter"];
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["filterType"] = this.filterType;
        data["value"] = this.value;
        data["joinType"] = this.joinType;
        if (Array.isArray(this.groupFilters)) {
            data["groupFilters"] = [];
            for (let item of this.groupFilters)
                data["groupFilters"].push(item.toJSON());
        }
        data["isGroupFilter"] = this.isGroupFilter;
        return data;
    }

    clone(): Filter {
        const json = this.toJSON();
        let result = new Filter();
        result.init(json);
        return result;
    }
}

export interface IFilter {
    field?: string | undefined;
    filterType?: FilterType;
    value?: string | undefined;
    joinType?: JoinType;
    groupFilters?: IFilter[] | undefined;
    isGroupFilter?: boolean;
}

export class OrderBy implements IOrderBy {
    field?: string | undefined;
    ascending?: boolean;

    constructor(data?: IOrderBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.ascending = _data["ascending"];
        }
    }

    static fromJS(data: any): OrderBy {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["ascending"] = this.ascending;
        return data;
    }

    clone(): OrderBy {
        const json = this.toJSON();
        let result = new OrderBy();
        result.init(json);
        return result;
    }
}

export interface IOrderBy {
    field?: string | undefined;
    ascending?: boolean;
}

export class GetAllPlayersByFilterCommandRequest implements IGetAllPlayersByFilterCommandRequest {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllPlayersByFilterCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllPlayersByFilterCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPlayersByFilterCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllPlayersByFilterCommandRequest {
        const json = this.toJSON();
        let result = new GetAllPlayersByFilterCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllPlayersByFilterCommandRequest {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class SlimPlayer implements ISlimPlayer {
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loggedIn?: boolean;
    lastActivityTime?: string | undefined;
    userId?: string | undefined;
    status?: UserStatus;
    forcePasswordChange?: boolean;
    emailConfirmed?: boolean;
    rankScore?: number;
    rankName?: PlayerRank;
    hints?: number;
    boards?: number;
    moreTime?: number;
    lastBoardAdsWatchDate?: string | undefined;
    lastHintAdsWatchDate?: string | undefined;
    lastMoreTimeAdsWatchDate?: string | undefined;

    constructor(data?: ISlimPlayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.loggedIn = _data["loggedIn"];
            this.lastActivityTime = _data["lastActivityTime"];
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.forcePasswordChange = _data["forcePasswordChange"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.rankScore = _data["rankScore"];
            this.rankName = _data["rankName"];
            this.hints = _data["hints"];
            this.boards = _data["boards"];
            this.moreTime = _data["moreTime"];
            this.lastBoardAdsWatchDate = _data["lastBoardAdsWatchDate"];
            this.lastHintAdsWatchDate = _data["lastHintAdsWatchDate"];
            this.lastMoreTimeAdsWatchDate = _data["lastMoreTimeAdsWatchDate"];
        }
    }

    static fromJS(data: any): SlimPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new SlimPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["loggedIn"] = this.loggedIn;
        data["lastActivityTime"] = this.lastActivityTime;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["forcePasswordChange"] = this.forcePasswordChange;
        data["emailConfirmed"] = this.emailConfirmed;
        data["rankScore"] = this.rankScore;
        data["rankName"] = this.rankName;
        data["hints"] = this.hints;
        data["boards"] = this.boards;
        data["moreTime"] = this.moreTime;
        data["lastBoardAdsWatchDate"] = this.lastBoardAdsWatchDate;
        data["lastHintAdsWatchDate"] = this.lastHintAdsWatchDate;
        data["lastMoreTimeAdsWatchDate"] = this.lastMoreTimeAdsWatchDate;
        return data;
    }

    clone(): SlimPlayer {
        const json = this.toJSON();
        let result = new SlimPlayer();
        result.init(json);
        return result;
    }
}

export interface ISlimPlayer {
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loggedIn?: boolean;
    lastActivityTime?: string | undefined;
    userId?: string | undefined;
    status?: UserStatus;
    forcePasswordChange?: boolean;
    emailConfirmed?: boolean;
    rankScore?: number;
    rankName?: PlayerRank;
    hints?: number;
    boards?: number;
    moreTime?: number;
    lastBoardAdsWatchDate?: string | undefined;
    lastHintAdsWatchDate?: string | undefined;
    lastMoreTimeAdsWatchDate?: string | undefined;
}

export class GetAllPlayersByFilterCommandResponse implements IGetAllPlayersByFilterCommandResponse {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: SlimPlayer[] | undefined;
    count?: number;

    constructor(data?: IGetAllPlayersByFilterCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SlimPlayer(item) : <SlimPlayer>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SlimPlayer.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllPlayersByFilterCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPlayersByFilterCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetAllPlayersByFilterCommandResponse {
        const json = this.toJSON();
        let result = new GetAllPlayersByFilterCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllPlayersByFilterCommandResponse {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ISlimPlayer[] | undefined;
    count?: number;
}

export class GetAllAdminsByFilterCommandRequest implements IGetAllAdminsByFilterCommandRequest {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllAdminsByFilterCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllAdminsByFilterCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAdminsByFilterCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAllAdminsByFilterCommandRequest {
        const json = this.toJSON();
        let result = new GetAllAdminsByFilterCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllAdminsByFilterCommandRequest {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class SlimAdministrator implements ISlimAdministrator {
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loggedIn?: boolean;
    userId?: string | undefined;
    status?: UserStatus;
    adminStatus?: UserStatus;
    forcePasswordChange?: boolean;
    emailConfirmed?: boolean;
    roles?: string[] | undefined;
    roleIds?: string[] | undefined;
    operations?: string[] | undefined;

    constructor(data?: ISlimAdministrator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.loggedIn = _data["loggedIn"];
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.adminStatus = _data["adminStatus"];
            this.forcePasswordChange = _data["forcePasswordChange"];
            this.emailConfirmed = _data["emailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
        }
    }

    static fromJS(data: any): SlimAdministrator {
        data = typeof data === 'object' ? data : {};
        let result = new SlimAdministrator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["loggedIn"] = this.loggedIn;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["adminStatus"] = this.adminStatus;
        data["forcePasswordChange"] = this.forcePasswordChange;
        data["emailConfirmed"] = this.emailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        return data;
    }

    clone(): SlimAdministrator {
        const json = this.toJSON();
        let result = new SlimAdministrator();
        result.init(json);
        return result;
    }
}

export interface ISlimAdministrator {
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loggedIn?: boolean;
    userId?: string | undefined;
    status?: UserStatus;
    adminStatus?: UserStatus;
    forcePasswordChange?: boolean;
    emailConfirmed?: boolean;
    roles?: string[] | undefined;
    roleIds?: string[] | undefined;
    operations?: string[] | undefined;
}

export class GetAllAdminsByFilterCommandResponse implements IGetAllAdminsByFilterCommandResponse {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: SlimAdministrator[] | undefined;
    count?: number;

    constructor(data?: IGetAllAdminsByFilterCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SlimAdministrator(item) : <SlimAdministrator>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SlimAdministrator.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllAdminsByFilterCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAdminsByFilterCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetAllAdminsByFilterCommandResponse {
        const json = this.toJSON();
        let result = new GetAllAdminsByFilterCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllAdminsByFilterCommandResponse {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ISlimAdministrator[] | undefined;
    count?: number;
}

export class GetPointsCommandRequest implements IGetPointsCommandRequest {
    playerUserNames?: string[] | undefined;

    constructor(data?: IGetPointsCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["playerUserNames"])) {
                this.playerUserNames = [] as any;
                for (let item of _data["playerUserNames"])
                    this.playerUserNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPointsCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPointsCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.playerUserNames)) {
            data["playerUserNames"] = [];
            for (let item of this.playerUserNames)
                data["playerUserNames"].push(item);
        }
        return data;
    }

    clone(): GetPointsCommandRequest {
        const json = this.toJSON();
        let result = new GetPointsCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPointsCommandRequest {
    playerUserNames?: string[] | undefined;
}

export class PlayerPoints implements IPlayerPoints {
    userName?: string | undefined;
    readonly totalPoints?: number;
    gamesPlayed?: number;
    gamesIncomplete?: number;
    practiceGames?: number;
    vsGames?: number;
    invitedPoints?: number;
    valid?: boolean;

    constructor(data?: IPlayerPoints) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            (<any>this).totalPoints = _data["totalPoints"];
            this.gamesPlayed = _data["gamesPlayed"];
            this.gamesIncomplete = _data["gamesIncomplete"];
            this.practiceGames = _data["practiceGames"];
            this.vsGames = _data["vsGames"];
            this.invitedPoints = _data["invitedPoints"];
            this.valid = _data["valid"];
        }
    }

    static fromJS(data: any): PlayerPoints {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerPoints();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["totalPoints"] = this.totalPoints;
        data["gamesPlayed"] = this.gamesPlayed;
        data["gamesIncomplete"] = this.gamesIncomplete;
        data["practiceGames"] = this.practiceGames;
        data["vsGames"] = this.vsGames;
        data["invitedPoints"] = this.invitedPoints;
        data["valid"] = this.valid;
        return data;
    }

    clone(): PlayerPoints {
        const json = this.toJSON();
        let result = new PlayerPoints();
        result.init(json);
        return result;
    }
}

export interface IPlayerPoints {
    userName?: string | undefined;
    totalPoints?: number;
    gamesPlayed?: number;
    gamesIncomplete?: number;
    practiceGames?: number;
    vsGames?: number;
    invitedPoints?: number;
    valid?: boolean;
}

export class GetPointsCommandResponse implements IGetPointsCommandResponse {
    readonly totalPointsCount?: number;
    players?: PlayerPoints[] | undefined;

    constructor(data?: IGetPointsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.players) {
                this.players = [];
                for (let i = 0; i < data.players.length; i++) {
                    let item = data.players[i];
                    this.players[i] = item && !(<any>item).toJSON ? new PlayerPoints(item) : <PlayerPoints>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).totalPointsCount = _data["totalPointsCount"];
            if (Array.isArray(_data["players"])) {
                this.players = [] as any;
                for (let item of _data["players"])
                    this.players!.push(PlayerPoints.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPointsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPointsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPointsCount"] = this.totalPointsCount;
        if (Array.isArray(this.players)) {
            data["players"] = [];
            for (let item of this.players)
                data["players"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPointsCommandResponse {
        const json = this.toJSON();
        let result = new GetPointsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPointsCommandResponse {
    totalPointsCount?: number;
    players?: IPlayerPoints[] | undefined;
}

export enum RoleStatus {
    Disabled = "Disabled",
    Active = "Active",
}

export class RoleListView implements IRoleListView {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    status?: RoleStatus;
    creationDate?: string | undefined;
    permissionCount?: number;

    constructor(data?: IRoleListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.creationDate = _data["creationDate"];
            this.permissionCount = _data["permissionCount"];
        }
    }

    static fromJS(data: any): RoleListView {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["creationDate"] = this.creationDate;
        data["permissionCount"] = this.permissionCount;
        return data;
    }

    clone(): RoleListView {
        const json = this.toJSON();
        let result = new RoleListView();
        result.init(json);
        return result;
    }
}

export interface IRoleListView {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    status?: RoleStatus;
    creationDate?: string | undefined;
    permissionCount?: number;
}

export class GetAllRolesByFilterCommandResponse implements IGetAllRolesByFilterCommandResponse {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: RoleListView[] | undefined;
    count?: number;

    constructor(data?: IGetAllRolesByFilterCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new RoleListView(item) : <RoleListView>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RoleListView.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAllRolesByFilterCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRolesByFilterCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetAllRolesByFilterCommandResponse {
        const json = this.toJSON();
        let result = new GetAllRolesByFilterCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllRolesByFilterCommandResponse {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IRoleListView[] | undefined;
    count?: number;
}

export class AddAdminUserCommandRequest implements IAddAdminUserCommandRequest {
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    accessCards?: string[] | undefined;
    adminStatus?: UserStatus;
    isSeniorAdmin?: boolean;

    constructor(data?: IAddAdminUserCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["accessCards"])) {
                this.accessCards = [] as any;
                for (let item of _data["accessCards"])
                    this.accessCards!.push(item);
            }
            this.adminStatus = _data["adminStatus"];
            this.isSeniorAdmin = _data["isSeniorAdmin"];
        }
    }

    static fromJS(data: any): AddAdminUserCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddAdminUserCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.accessCards)) {
            data["accessCards"] = [];
            for (let item of this.accessCards)
                data["accessCards"].push(item);
        }
        data["adminStatus"] = this.adminStatus;
        data["isSeniorAdmin"] = this.isSeniorAdmin;
        return data;
    }

    clone(): AddAdminUserCommandRequest {
        const json = this.toJSON();
        let result = new AddAdminUserCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddAdminUserCommandRequest {
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    accessCards?: string[] | undefined;
    adminStatus?: UserStatus;
    isSeniorAdmin?: boolean;
}

export class IdentityError implements IIdentityError {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }

    clone(): IdentityError {
        const json = this.toJSON();
        let result = new IdentityError();
        result.init(json);
        return result;
    }
}

export interface IIdentityError {
    code?: string | undefined;
    description?: string | undefined;
}

export class IdentityResult implements IIdentityResult {
    readonly succeeded?: boolean;
    readonly errors?: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.errors) {
                this.errors = [];
                for (let i = 0; i < data.errors.length; i++) {
                    let item = data.errors[i];
                    this.errors[i] = item && !(<any>item).toJSON ? new IdentityError(item) : <IdentityError>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }

    clone(): IdentityResult {
        const json = this.toJSON();
        let result = new IdentityResult();
        result.init(json);
        return result;
    }
}

export interface IIdentityResult {
    succeeded?: boolean;
    errors?: IIdentityError[] | undefined;
}

export class SlimUser implements ISlimUser {
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loggedIn?: boolean;
    userId?: string | undefined;
    status?: UserStatus;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
    forcePasswordChange?: boolean;
    emailConfirmed?: boolean;
    sessionId?: string | undefined;
    roles?: string[] | undefined;
    roleIds?: string[] | undefined;
    operations?: Operations[] | undefined;

    constructor(data?: ISlimUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.loggedIn = _data["loggedIn"];
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            this.accessToken = _data["accessToken"];
            this.forcePasswordChange = _data["forcePasswordChange"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.sessionId = _data["sessionId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
        }
    }

    static fromJS(data: any): SlimUser {
        data = typeof data === 'object' ? data : {};
        let result = new SlimUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["loggedIn"] = this.loggedIn;
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["accessToken"] = this.accessToken;
        data["forcePasswordChange"] = this.forcePasswordChange;
        data["emailConfirmed"] = this.emailConfirmed;
        data["sessionId"] = this.sessionId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        return data;
    }

    clone(): SlimUser {
        const json = this.toJSON();
        let result = new SlimUser();
        result.init(json);
        return result;
    }
}

export interface ISlimUser {
    username?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loggedIn?: boolean;
    userId?: string | undefined;
    status?: UserStatus;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
    forcePasswordChange?: boolean;
    emailConfirmed?: boolean;
    sessionId?: string | undefined;
    roles?: string[] | undefined;
    roleIds?: string[] | undefined;
    operations?: Operations[] | undefined;
}

export class AddAdminUserCommandResponse implements IAddAdminUserCommandResponse {
    readonly result?: IdentityResult | undefined;
    adminUser?: SlimUser | undefined;

    constructor(data?: IAddAdminUserCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new IdentityResult(data.result) : <IdentityResult>this.result;
            this.adminUser = data.adminUser && !(<any>data.adminUser).toJSON ? new SlimUser(data.adminUser) : <SlimUser>this.adminUser;
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            this.adminUser = _data["adminUser"] ? SlimUser.fromJS(_data["adminUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddAdminUserCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddAdminUserCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["adminUser"] = this.adminUser ? this.adminUser.toJSON() : <any>undefined;
        return data;
    }

    clone(): AddAdminUserCommandResponse {
        const json = this.toJSON();
        let result = new AddAdminUserCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddAdminUserCommandResponse {
    result?: IIdentityResult | undefined;
    adminUser?: ISlimUser | undefined;
}

export class GetPlayerGamesByUserIdAndFilterCommandRequest implements IGetPlayerGamesByUserIdAndFilterCommandRequest {
    id?: string;
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetPlayerGamesByUserIdAndFilterCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPlayerGamesByUserIdAndFilterCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerGamesByUserIdAndFilterCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPlayerGamesByUserIdAndFilterCommandRequest {
        const json = this.toJSON();
        let result = new GetPlayerGamesByUserIdAndFilterCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerGamesByUserIdAndFilterCommandRequest {
    id?: string;
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export enum GameStatus {
    Pending = "Pending",
    InProgress = "InProgress",
    Completed = "Completed",
    Expired = "Expired",
    Cancelled = "Cancelled",
}

export class GameListItem implements IGameListItem {
    id?: string;
    currentBoard?: string | undefined;
    status?: GameStatus;
    isSinglePlayer?: boolean;
    botGame?: boolean;
    ranked?: boolean;
    isGameValid?: boolean;
    createdAt?: string | undefined;
    finishedAt?: string | undefined;
    playerOneScore?: number | undefined;
    playerTwoScore?: number | undefined;

    constructor(data?: IGameListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.currentBoard = _data["currentBoard"];
            this.status = _data["status"];
            this.isSinglePlayer = _data["isSinglePlayer"];
            this.botGame = _data["botGame"];
            this.ranked = _data["ranked"];
            this.isGameValid = _data["isGameValid"];
            this.createdAt = _data["createdAt"];
            this.finishedAt = _data["finishedAt"];
            this.playerOneScore = _data["playerOneScore"];
            this.playerTwoScore = _data["playerTwoScore"];
        }
    }

    static fromJS(data: any): GameListItem {
        data = typeof data === 'object' ? data : {};
        let result = new GameListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currentBoard"] = this.currentBoard;
        data["status"] = this.status;
        data["isSinglePlayer"] = this.isSinglePlayer;
        data["botGame"] = this.botGame;
        data["ranked"] = this.ranked;
        data["isGameValid"] = this.isGameValid;
        data["createdAt"] = this.createdAt;
        data["finishedAt"] = this.finishedAt;
        data["playerOneScore"] = this.playerOneScore;
        data["playerTwoScore"] = this.playerTwoScore;
        return data;
    }

    clone(): GameListItem {
        const json = this.toJSON();
        let result = new GameListItem();
        result.init(json);
        return result;
    }
}

export interface IGameListItem {
    id?: string;
    currentBoard?: string | undefined;
    status?: GameStatus;
    isSinglePlayer?: boolean;
    botGame?: boolean;
    ranked?: boolean;
    isGameValid?: boolean;
    createdAt?: string | undefined;
    finishedAt?: string | undefined;
    playerOneScore?: number | undefined;
    playerTwoScore?: number | undefined;
}

export class GetPlayerGamesByUserIdAndFilterCommandResponse implements IGetPlayerGamesByUserIdAndFilterCommandResponse {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: GameListItem[] | undefined;
    count?: number;

    constructor(data?: IGetPlayerGamesByUserIdAndFilterCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new GameListItem(item) : <GameListItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(GameListItem.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetPlayerGamesByUserIdAndFilterCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerGamesByUserIdAndFilterCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }

    clone(): GetPlayerGamesByUserIdAndFilterCommandResponse {
        const json = this.toJSON();
        let result = new GetPlayerGamesByUserIdAndFilterCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerGamesByUserIdAndFilterCommandResponse {
    pageNumber?: number;
    amountPerPage?: number | undefined;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: IGameListItem[] | undefined;
    count?: number;
}

export enum PlayerStatus {
    Playing = "Playing",
    Win = "Win",
    Lose = "Lose",
    Draw = "Draw",
    Forfeit = "Forfeit",
}

export class PlayerStateDetail implements IPlayerStateDetail {
    userId?: string;
    score?: number;
    remainingMoves?: number;
    errors?: number;
    hintsUsed?: number;
    moreTimeUsed?: number;
    adsWatched?: number;
    timeTaken?: number;
    playerStatus?: PlayerStatus;

    constructor(data?: IPlayerStateDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.score = _data["score"];
            this.remainingMoves = _data["remainingMoves"];
            this.errors = _data["errors"];
            this.hintsUsed = _data["hintsUsed"];
            this.moreTimeUsed = _data["moreTimeUsed"];
            this.adsWatched = _data["adsWatched"];
            this.timeTaken = _data["timeTaken"];
            this.playerStatus = _data["playerStatus"];
        }
    }

    static fromJS(data: any): PlayerStateDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerStateDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["score"] = this.score;
        data["remainingMoves"] = this.remainingMoves;
        data["errors"] = this.errors;
        data["hintsUsed"] = this.hintsUsed;
        data["moreTimeUsed"] = this.moreTimeUsed;
        data["adsWatched"] = this.adsWatched;
        data["timeTaken"] = this.timeTaken;
        data["playerStatus"] = this.playerStatus;
        return data;
    }

    clone(): PlayerStateDetail {
        const json = this.toJSON();
        let result = new PlayerStateDetail();
        result.init(json);
        return result;
    }
}

export interface IPlayerStateDetail {
    userId?: string;
    score?: number;
    remainingMoves?: number;
    errors?: number;
    hintsUsed?: number;
    moreTimeUsed?: number;
    adsWatched?: number;
    timeTaken?: number;
    playerStatus?: PlayerStatus;
}

export class GameDetail implements IGameDetail {
    id?: string;
    gameDifficulty?: Difficulty;
    status?: GameStatus;
    isSinglePlayer?: boolean;
    botGame?: boolean;
    ranked?: boolean;
    isGameValid?: boolean;
    currentBoard?: string | undefined;
    solution?: string | undefined;
    playerOneId?: string;
    playerTwoId?: string | undefined;
    createdAt?: string | undefined;
    finishedAt?: string | undefined;
    playerOne?: PlayerStateDetail | undefined;
    playerTwo?: PlayerStateDetail | undefined;
    currentPlayersTurn?: string | undefined;

    constructor(data?: IGameDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerOne = data.playerOne && !(<any>data.playerOne).toJSON ? new PlayerStateDetail(data.playerOne) : <PlayerStateDetail>this.playerOne;
            this.playerTwo = data.playerTwo && !(<any>data.playerTwo).toJSON ? new PlayerStateDetail(data.playerTwo) : <PlayerStateDetail>this.playerTwo;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gameDifficulty = _data["gameDifficulty"];
            this.status = _data["status"];
            this.isSinglePlayer = _data["isSinglePlayer"];
            this.botGame = _data["botGame"];
            this.ranked = _data["ranked"];
            this.isGameValid = _data["isGameValid"];
            this.currentBoard = _data["currentBoard"];
            this.solution = _data["solution"];
            this.playerOneId = _data["playerOneId"];
            this.playerTwoId = _data["playerTwoId"];
            this.createdAt = _data["createdAt"];
            this.finishedAt = _data["finishedAt"];
            this.playerOne = _data["playerOne"] ? PlayerStateDetail.fromJS(_data["playerOne"]) : <any>undefined;
            this.playerTwo = _data["playerTwo"] ? PlayerStateDetail.fromJS(_data["playerTwo"]) : <any>undefined;
            this.currentPlayersTurn = _data["currentPlayersTurn"];
        }
    }

    static fromJS(data: any): GameDetail {
        data = typeof data === 'object' ? data : {};
        let result = new GameDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gameDifficulty"] = this.gameDifficulty;
        data["status"] = this.status;
        data["isSinglePlayer"] = this.isSinglePlayer;
        data["botGame"] = this.botGame;
        data["ranked"] = this.ranked;
        data["isGameValid"] = this.isGameValid;
        data["currentBoard"] = this.currentBoard;
        data["solution"] = this.solution;
        data["playerOneId"] = this.playerOneId;
        data["playerTwoId"] = this.playerTwoId;
        data["createdAt"] = this.createdAt;
        data["finishedAt"] = this.finishedAt;
        data["playerOne"] = this.playerOne ? this.playerOne.toJSON() : <any>undefined;
        data["playerTwo"] = this.playerTwo ? this.playerTwo.toJSON() : <any>undefined;
        data["currentPlayersTurn"] = this.currentPlayersTurn;
        return data;
    }

    clone(): GameDetail {
        const json = this.toJSON();
        let result = new GameDetail();
        result.init(json);
        return result;
    }
}

export interface IGameDetail {
    id?: string;
    gameDifficulty?: Difficulty;
    status?: GameStatus;
    isSinglePlayer?: boolean;
    botGame?: boolean;
    ranked?: boolean;
    isGameValid?: boolean;
    currentBoard?: string | undefined;
    solution?: string | undefined;
    playerOneId?: string;
    playerTwoId?: string | undefined;
    createdAt?: string | undefined;
    finishedAt?: string | undefined;
    playerOne?: IPlayerStateDetail | undefined;
    playerTwo?: IPlayerStateDetail | undefined;
    currentPlayersTurn?: string | undefined;
}

export class GetPlayerGameDetailsByGameIdCommandResponse implements IGetPlayerGameDetailsByGameIdCommandResponse {
    success?: boolean;
    game?: GameDetail | undefined;

    constructor(data?: IGetPlayerGameDetailsByGameIdCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.game = data.game && !(<any>data.game).toJSON ? new GameDetail(data.game) : <GameDetail>this.game;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.game = _data["game"] ? GameDetail.fromJS(_data["game"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlayerGameDetailsByGameIdCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerGameDetailsByGameIdCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["game"] = this.game ? this.game.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetPlayerGameDetailsByGameIdCommandResponse {
        const json = this.toJSON();
        let result = new GetPlayerGameDetailsByGameIdCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerGameDetailsByGameIdCommandResponse {
    success?: boolean;
    game?: IGameDetail | undefined;
}

export class GetPlayerByUserIdCommandResponse implements IGetPlayerByUserIdCommandResponse {
    success?: boolean;
    player?: SlimPlayer | undefined;

    constructor(data?: IGetPlayerByUserIdCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.player = data.player && !(<any>data.player).toJSON ? new SlimPlayer(data.player) : <SlimPlayer>this.player;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.player = _data["player"] ? SlimPlayer.fromJS(_data["player"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlayerByUserIdCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerByUserIdCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetPlayerByUserIdCommandResponse {
        const json = this.toJSON();
        let result = new GetPlayerByUserIdCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerByUserIdCommandResponse {
    success?: boolean;
    player?: ISlimPlayer | undefined;
}

export class PlayerHeaderInfo implements IPlayerHeaderInfo {
    username?: string | undefined;
    email?: string | undefined;
    joinDate?: string | undefined;
    rankName?: PlayerRank;
    rankScore?: number;
    highestRating?: number;
    friendsCount?: number;
    achievementsCompleted?: number;
    totalAchievements?: number;
    vsHighScore?: number;
    singleModeBestTime?: number | undefined;
    lastActivity?: string | undefined;
    isOnline?: boolean;

    constructor(data?: IPlayerHeaderInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.email = _data["email"];
            this.joinDate = _data["joinDate"];
            this.rankName = _data["rankName"];
            this.rankScore = _data["rankScore"];
            this.highestRating = _data["highestRating"];
            this.friendsCount = _data["friendsCount"];
            this.achievementsCompleted = _data["achievementsCompleted"];
            this.totalAchievements = _data["totalAchievements"];
            this.vsHighScore = _data["vsHighScore"];
            this.singleModeBestTime = _data["singleModeBestTime"];
            this.lastActivity = _data["lastActivity"];
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): PlayerHeaderInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerHeaderInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["joinDate"] = this.joinDate;
        data["rankName"] = this.rankName;
        data["rankScore"] = this.rankScore;
        data["highestRating"] = this.highestRating;
        data["friendsCount"] = this.friendsCount;
        data["achievementsCompleted"] = this.achievementsCompleted;
        data["totalAchievements"] = this.totalAchievements;
        data["vsHighScore"] = this.vsHighScore;
        data["singleModeBestTime"] = this.singleModeBestTime;
        data["lastActivity"] = this.lastActivity;
        data["isOnline"] = this.isOnline;
        return data;
    }

    clone(): PlayerHeaderInfo {
        const json = this.toJSON();
        let result = new PlayerHeaderInfo();
        result.init(json);
        return result;
    }
}

export interface IPlayerHeaderInfo {
    username?: string | undefined;
    email?: string | undefined;
    joinDate?: string | undefined;
    rankName?: PlayerRank;
    rankScore?: number;
    highestRating?: number;
    friendsCount?: number;
    achievementsCompleted?: number;
    totalAchievements?: number;
    vsHighScore?: number;
    singleModeBestTime?: number | undefined;
    lastActivity?: string | undefined;
    isOnline?: boolean;
}

export class PlayerAchievementItem implements IPlayerAchievementItem {
    title?: string | undefined;
    description?: string | undefined;
    grantedAt?: string;

    constructor(data?: IPlayerAchievementItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.grantedAt = _data["grantedAt"];
        }
    }

    static fromJS(data: any): PlayerAchievementItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerAchievementItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["grantedAt"] = this.grantedAt;
        return data;
    }

    clone(): PlayerAchievementItem {
        const json = this.toJSON();
        let result = new PlayerAchievementItem();
        result.init(json);
        return result;
    }
}

export interface IPlayerAchievementItem {
    title?: string | undefined;
    description?: string | undefined;
    grantedAt?: string;
}

export class DifficultyBreakdown implements IDifficultyBreakdown {
    difficulty?: string | undefined;
    gamesPlayed?: number;
    avgErrors?: number;
    avgHints?: number;
    bestTime?: number;
    avgTime?: number;
    worstTime?: number;

    constructor(data?: IDifficultyBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.difficulty = _data["difficulty"];
            this.gamesPlayed = _data["gamesPlayed"];
            this.avgErrors = _data["avgErrors"];
            this.avgHints = _data["avgHints"];
            this.bestTime = _data["bestTime"];
            this.avgTime = _data["avgTime"];
            this.worstTime = _data["worstTime"];
        }
    }

    static fromJS(data: any): DifficultyBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new DifficultyBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["difficulty"] = this.difficulty;
        data["gamesPlayed"] = this.gamesPlayed;
        data["avgErrors"] = this.avgErrors;
        data["avgHints"] = this.avgHints;
        data["bestTime"] = this.bestTime;
        data["avgTime"] = this.avgTime;
        data["worstTime"] = this.worstTime;
        return data;
    }

    clone(): DifficultyBreakdown {
        const json = this.toJSON();
        let result = new DifficultyBreakdown();
        result.init(json);
        return result;
    }
}

export interface IDifficultyBreakdown {
    difficulty?: string | undefined;
    gamesPlayed?: number;
    avgErrors?: number;
    avgHints?: number;
    bestTime?: number;
    avgTime?: number;
    worstTime?: number;
}

export class SingleModeStats implements ISingleModeStats {
    gamesAttempted?: number;
    gamesCompleted?: number;
    gamesFailed?: number;
    byDifficulty?: DifficultyBreakdown[] | undefined;

    constructor(data?: ISingleModeStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.byDifficulty) {
                this.byDifficulty = [];
                for (let i = 0; i < data.byDifficulty.length; i++) {
                    let item = data.byDifficulty[i];
                    this.byDifficulty[i] = item && !(<any>item).toJSON ? new DifficultyBreakdown(item) : <DifficultyBreakdown>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gamesAttempted = _data["gamesAttempted"];
            this.gamesCompleted = _data["gamesCompleted"];
            this.gamesFailed = _data["gamesFailed"];
            if (Array.isArray(_data["byDifficulty"])) {
                this.byDifficulty = [] as any;
                for (let item of _data["byDifficulty"])
                    this.byDifficulty!.push(DifficultyBreakdown.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SingleModeStats {
        data = typeof data === 'object' ? data : {};
        let result = new SingleModeStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gamesAttempted"] = this.gamesAttempted;
        data["gamesCompleted"] = this.gamesCompleted;
        data["gamesFailed"] = this.gamesFailed;
        if (Array.isArray(this.byDifficulty)) {
            data["byDifficulty"] = [];
            for (let item of this.byDifficulty)
                data["byDifficulty"].push(item.toJSON());
        }
        return data;
    }

    clone(): SingleModeStats {
        const json = this.toJSON();
        let result = new SingleModeStats();
        result.init(json);
        return result;
    }
}

export interface ISingleModeStats {
    gamesAttempted?: number;
    gamesCompleted?: number;
    gamesFailed?: number;
    byDifficulty?: IDifficultyBreakdown[] | undefined;
}

export class VsModeStats implements IVsModeStats {
    gamesPlayed?: number;
    wins?: number;
    losses?: number;
    highestScore?: number;
    lowestScore?: number;
    avgScore?: number;
    avgHints?: number;
    avgErrors?: number;
    avgInputs?: number;

    constructor(data?: IVsModeStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gamesPlayed = _data["gamesPlayed"];
            this.wins = _data["wins"];
            this.losses = _data["losses"];
            this.highestScore = _data["highestScore"];
            this.lowestScore = _data["lowestScore"];
            this.avgScore = _data["avgScore"];
            this.avgHints = _data["avgHints"];
            this.avgErrors = _data["avgErrors"];
            this.avgInputs = _data["avgInputs"];
        }
    }

    static fromJS(data: any): VsModeStats {
        data = typeof data === 'object' ? data : {};
        let result = new VsModeStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gamesPlayed"] = this.gamesPlayed;
        data["wins"] = this.wins;
        data["losses"] = this.losses;
        data["highestScore"] = this.highestScore;
        data["lowestScore"] = this.lowestScore;
        data["avgScore"] = this.avgScore;
        data["avgHints"] = this.avgHints;
        data["avgErrors"] = this.avgErrors;
        data["avgInputs"] = this.avgInputs;
        return data;
    }

    clone(): VsModeStats {
        const json = this.toJSON();
        let result = new VsModeStats();
        result.init(json);
        return result;
    }
}

export interface IVsModeStats {
    gamesPlayed?: number;
    wins?: number;
    losses?: number;
    highestScore?: number;
    lowestScore?: number;
    avgScore?: number;
    avgHints?: number;
    avgErrors?: number;
    avgInputs?: number;
}

export class DailyChallengeStats implements IDailyChallengeStats {
    gamesPlayed?: number;
    gamesCompleted?: number;
    gamesFailed?: number;
    bestTime?: number | undefined;
    worstTime?: number | undefined;
    avgScore?: number;
    avgHints?: number;
    avgErrors?: number;

    constructor(data?: IDailyChallengeStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gamesPlayed = _data["gamesPlayed"];
            this.gamesCompleted = _data["gamesCompleted"];
            this.gamesFailed = _data["gamesFailed"];
            this.bestTime = _data["bestTime"];
            this.worstTime = _data["worstTime"];
            this.avgScore = _data["avgScore"];
            this.avgHints = _data["avgHints"];
            this.avgErrors = _data["avgErrors"];
        }
    }

    static fromJS(data: any): DailyChallengeStats {
        data = typeof data === 'object' ? data : {};
        let result = new DailyChallengeStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gamesPlayed"] = this.gamesPlayed;
        data["gamesCompleted"] = this.gamesCompleted;
        data["gamesFailed"] = this.gamesFailed;
        data["bestTime"] = this.bestTime;
        data["worstTime"] = this.worstTime;
        data["avgScore"] = this.avgScore;
        data["avgHints"] = this.avgHints;
        data["avgErrors"] = this.avgErrors;
        return data;
    }

    clone(): DailyChallengeStats {
        const json = this.toJSON();
        let result = new DailyChallengeStats();
        result.init(json);
        return result;
    }
}

export interface IDailyChallengeStats {
    gamesPlayed?: number;
    gamesCompleted?: number;
    gamesFailed?: number;
    bestTime?: number | undefined;
    worstTime?: number | undefined;
    avgScore?: number;
    avgHints?: number;
    avgErrors?: number;
}

export class PurchaseItem implements IPurchaseItem {
    productName?: string | undefined;
    purchaseDate?: string;
    amount?: number;

    constructor(data?: IPurchaseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.purchaseDate = _data["purchaseDate"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): PurchaseItem {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["purchaseDate"] = this.purchaseDate;
        data["amount"] = this.amount;
        return data;
    }

    clone(): PurchaseItem {
        const json = this.toJSON();
        let result = new PurchaseItem();
        result.init(json);
        return result;
    }
}

export interface IPurchaseItem {
    productName?: string | undefined;
    purchaseDate?: string;
    amount?: number;
}

export class PlayerDetailResponse implements IPlayerDetailResponse {
    header?: PlayerHeaderInfo | undefined;
    achievements?: PlayerAchievementItem[] | undefined;
    singleModeStats?: SingleModeStats | undefined;
    vsModeStats?: VsModeStats | undefined;
    vsBotStats?: VsModeStats | undefined;
    dailyChallengeStats?: DailyChallengeStats | undefined;
    purchases?: PurchaseItem[] | undefined;

    constructor(data?: IPlayerDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.header = data.header && !(<any>data.header).toJSON ? new PlayerHeaderInfo(data.header) : <PlayerHeaderInfo>this.header;
            if (data.achievements) {
                this.achievements = [];
                for (let i = 0; i < data.achievements.length; i++) {
                    let item = data.achievements[i];
                    this.achievements[i] = item && !(<any>item).toJSON ? new PlayerAchievementItem(item) : <PlayerAchievementItem>item;
                }
            }
            this.singleModeStats = data.singleModeStats && !(<any>data.singleModeStats).toJSON ? new SingleModeStats(data.singleModeStats) : <SingleModeStats>this.singleModeStats;
            this.vsModeStats = data.vsModeStats && !(<any>data.vsModeStats).toJSON ? new VsModeStats(data.vsModeStats) : <VsModeStats>this.vsModeStats;
            this.vsBotStats = data.vsBotStats && !(<any>data.vsBotStats).toJSON ? new VsModeStats(data.vsBotStats) : <VsModeStats>this.vsBotStats;
            this.dailyChallengeStats = data.dailyChallengeStats && !(<any>data.dailyChallengeStats).toJSON ? new DailyChallengeStats(data.dailyChallengeStats) : <DailyChallengeStats>this.dailyChallengeStats;
            if (data.purchases) {
                this.purchases = [];
                for (let i = 0; i < data.purchases.length; i++) {
                    let item = data.purchases[i];
                    this.purchases[i] = item && !(<any>item).toJSON ? new PurchaseItem(item) : <PurchaseItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? PlayerHeaderInfo.fromJS(_data["header"]) : <any>undefined;
            if (Array.isArray(_data["achievements"])) {
                this.achievements = [] as any;
                for (let item of _data["achievements"])
                    this.achievements!.push(PlayerAchievementItem.fromJS(item));
            }
            this.singleModeStats = _data["singleModeStats"] ? SingleModeStats.fromJS(_data["singleModeStats"]) : <any>undefined;
            this.vsModeStats = _data["vsModeStats"] ? VsModeStats.fromJS(_data["vsModeStats"]) : <any>undefined;
            this.vsBotStats = _data["vsBotStats"] ? VsModeStats.fromJS(_data["vsBotStats"]) : <any>undefined;
            this.dailyChallengeStats = _data["dailyChallengeStats"] ? DailyChallengeStats.fromJS(_data["dailyChallengeStats"]) : <any>undefined;
            if (Array.isArray(_data["purchases"])) {
                this.purchases = [] as any;
                for (let item of _data["purchases"])
                    this.purchases!.push(PurchaseItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.achievements)) {
            data["achievements"] = [];
            for (let item of this.achievements)
                data["achievements"].push(item.toJSON());
        }
        data["singleModeStats"] = this.singleModeStats ? this.singleModeStats.toJSON() : <any>undefined;
        data["vsModeStats"] = this.vsModeStats ? this.vsModeStats.toJSON() : <any>undefined;
        data["vsBotStats"] = this.vsBotStats ? this.vsBotStats.toJSON() : <any>undefined;
        data["dailyChallengeStats"] = this.dailyChallengeStats ? this.dailyChallengeStats.toJSON() : <any>undefined;
        if (Array.isArray(this.purchases)) {
            data["purchases"] = [];
            for (let item of this.purchases)
                data["purchases"].push(item.toJSON());
        }
        return data;
    }

    clone(): PlayerDetailResponse {
        const json = this.toJSON();
        let result = new PlayerDetailResponse();
        result.init(json);
        return result;
    }
}

export interface IPlayerDetailResponse {
    header?: IPlayerHeaderInfo | undefined;
    achievements?: IPlayerAchievementItem[] | undefined;
    singleModeStats?: ISingleModeStats | undefined;
    vsModeStats?: IVsModeStats | undefined;
    vsBotStats?: IVsModeStats | undefined;
    dailyChallengeStats?: IDailyChallengeStats | undefined;
    purchases?: IPurchaseItem[] | undefined;
}

export class GetPlayerDetailsByUserIdCommandResponse implements IGetPlayerDetailsByUserIdCommandResponse {
    success?: boolean;
    playerDetail?: PlayerDetailResponse | undefined;

    constructor(data?: IGetPlayerDetailsByUserIdCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.playerDetail = data.playerDetail && !(<any>data.playerDetail).toJSON ? new PlayerDetailResponse(data.playerDetail) : <PlayerDetailResponse>this.playerDetail;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.playerDetail = _data["playerDetail"] ? PlayerDetailResponse.fromJS(_data["playerDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlayerDetailsByUserIdCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerDetailsByUserIdCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["playerDetail"] = this.playerDetail ? this.playerDetail.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetPlayerDetailsByUserIdCommandResponse {
        const json = this.toJSON();
        let result = new GetPlayerDetailsByUserIdCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlayerDetailsByUserIdCommandResponse {
    success?: boolean;
    playerDetail?: IPlayerDetailResponse | undefined;
}

export class DashboardQueryOnlineUsersResponse implements IDashboardQueryOnlineUsersResponse {
    count?: number;

    constructor(data?: IDashboardQueryOnlineUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): DashboardQueryOnlineUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardQueryOnlineUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data;
    }

    clone(): DashboardQueryOnlineUsersResponse {
        const json = this.toJSON();
        let result = new DashboardQueryOnlineUsersResponse();
        result.init(json);
        return result;
    }
}

export interface IDashboardQueryOnlineUsersResponse {
    count?: number;
}

export class GameHistoryDataPoint implements IGameHistoryDataPoint {
    label?: string | undefined;
    date?: string;
    dailyChallenge?: number;
    dailyChallengeCompleted?: number;
    dailyChallengeFailed?: number;
    vsRandom?: number;
    vsFriends?: number;
    vsBot?: number;
    singleMode?: number;
    vsRandomCompleted?: number;
    vsFriendsCompleted?: number;
    vsBotCompleted?: number;
    singleModeCompleted?: number;
    onlineUsers?: number;
    vsGamesStarted?: number;
    vsGamesCompleted?: number;

    constructor(data?: IGameHistoryDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.date = _data["date"];
            this.dailyChallenge = _data["dailyChallenge"];
            this.dailyChallengeCompleted = _data["dailyChallengeCompleted"];
            this.dailyChallengeFailed = _data["dailyChallengeFailed"];
            this.vsRandom = _data["vsRandom"];
            this.vsFriends = _data["vsFriends"];
            this.vsBot = _data["vsBot"];
            this.singleMode = _data["singleMode"];
            this.vsRandomCompleted = _data["vsRandomCompleted"];
            this.vsFriendsCompleted = _data["vsFriendsCompleted"];
            this.vsBotCompleted = _data["vsBotCompleted"];
            this.singleModeCompleted = _data["singleModeCompleted"];
            this.onlineUsers = _data["onlineUsers"];
            this.vsGamesStarted = _data["vsGamesStarted"];
            this.vsGamesCompleted = _data["vsGamesCompleted"];
        }
    }

    static fromJS(data: any): GameHistoryDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new GameHistoryDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date;
        data["dailyChallenge"] = this.dailyChallenge;
        data["dailyChallengeCompleted"] = this.dailyChallengeCompleted;
        data["dailyChallengeFailed"] = this.dailyChallengeFailed;
        data["vsRandom"] = this.vsRandom;
        data["vsFriends"] = this.vsFriends;
        data["vsBot"] = this.vsBot;
        data["singleMode"] = this.singleMode;
        data["vsRandomCompleted"] = this.vsRandomCompleted;
        data["vsFriendsCompleted"] = this.vsFriendsCompleted;
        data["vsBotCompleted"] = this.vsBotCompleted;
        data["singleModeCompleted"] = this.singleModeCompleted;
        data["onlineUsers"] = this.onlineUsers;
        data["vsGamesStarted"] = this.vsGamesStarted;
        data["vsGamesCompleted"] = this.vsGamesCompleted;
        return data;
    }

    clone(): GameHistoryDataPoint {
        const json = this.toJSON();
        let result = new GameHistoryDataPoint();
        result.init(json);
        return result;
    }
}

export interface IGameHistoryDataPoint {
    label?: string | undefined;
    date?: string;
    dailyChallenge?: number;
    dailyChallengeCompleted?: number;
    dailyChallengeFailed?: number;
    vsRandom?: number;
    vsFriends?: number;
    vsBot?: number;
    singleMode?: number;
    vsRandomCompleted?: number;
    vsFriendsCompleted?: number;
    vsBotCompleted?: number;
    singleModeCompleted?: number;
    onlineUsers?: number;
    vsGamesStarted?: number;
    vsGamesCompleted?: number;
}

export class PeriodComparison implements IPeriodComparison {
    currentPeriodTotal?: number;
    previousPeriodTotal?: number;
    percentageChange?: number;

    constructor(data?: IPeriodComparison) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPeriodTotal = _data["currentPeriodTotal"];
            this.previousPeriodTotal = _data["previousPeriodTotal"];
            this.percentageChange = _data["percentageChange"];
        }
    }

    static fromJS(data: any): PeriodComparison {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodComparison();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPeriodTotal"] = this.currentPeriodTotal;
        data["previousPeriodTotal"] = this.previousPeriodTotal;
        data["percentageChange"] = this.percentageChange;
        return data;
    }

    clone(): PeriodComparison {
        const json = this.toJSON();
        let result = new PeriodComparison();
        result.init(json);
        return result;
    }
}

export interface IPeriodComparison {
    currentPeriodTotal?: number;
    previousPeriodTotal?: number;
    percentageChange?: number;
}

export class GetGameHistoryCommandResponse implements IGetGameHistoryCommandResponse {
    success?: boolean;
    dataPoints?: GameHistoryDataPoint[] | undefined;
    totalGames?: number;
    vsGamesComparison?: PeriodComparison | undefined;
    singleGamesComparison?: PeriodComparison | undefined;
    dailyChallengeComparison?: PeriodComparison | undefined;
    vsBotComparison?: PeriodComparison | undefined;
    vsGamesCompletedComparison?: PeriodComparison | undefined;
    singleGamesCompletedComparison?: PeriodComparison | undefined;
    vsBotCompletedComparison?: PeriodComparison | undefined;

    constructor(data?: IGetGameHistoryCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.dataPoints) {
                this.dataPoints = [];
                for (let i = 0; i < data.dataPoints.length; i++) {
                    let item = data.dataPoints[i];
                    this.dataPoints[i] = item && !(<any>item).toJSON ? new GameHistoryDataPoint(item) : <GameHistoryDataPoint>item;
                }
            }
            this.vsGamesComparison = data.vsGamesComparison && !(<any>data.vsGamesComparison).toJSON ? new PeriodComparison(data.vsGamesComparison) : <PeriodComparison>this.vsGamesComparison;
            this.singleGamesComparison = data.singleGamesComparison && !(<any>data.singleGamesComparison).toJSON ? new PeriodComparison(data.singleGamesComparison) : <PeriodComparison>this.singleGamesComparison;
            this.dailyChallengeComparison = data.dailyChallengeComparison && !(<any>data.dailyChallengeComparison).toJSON ? new PeriodComparison(data.dailyChallengeComparison) : <PeriodComparison>this.dailyChallengeComparison;
            this.vsBotComparison = data.vsBotComparison && !(<any>data.vsBotComparison).toJSON ? new PeriodComparison(data.vsBotComparison) : <PeriodComparison>this.vsBotComparison;
            this.vsGamesCompletedComparison = data.vsGamesCompletedComparison && !(<any>data.vsGamesCompletedComparison).toJSON ? new PeriodComparison(data.vsGamesCompletedComparison) : <PeriodComparison>this.vsGamesCompletedComparison;
            this.singleGamesCompletedComparison = data.singleGamesCompletedComparison && !(<any>data.singleGamesCompletedComparison).toJSON ? new PeriodComparison(data.singleGamesCompletedComparison) : <PeriodComparison>this.singleGamesCompletedComparison;
            this.vsBotCompletedComparison = data.vsBotCompletedComparison && !(<any>data.vsBotCompletedComparison).toJSON ? new PeriodComparison(data.vsBotCompletedComparison) : <PeriodComparison>this.vsBotCompletedComparison;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["dataPoints"])) {
                this.dataPoints = [] as any;
                for (let item of _data["dataPoints"])
                    this.dataPoints!.push(GameHistoryDataPoint.fromJS(item));
            }
            this.totalGames = _data["totalGames"];
            this.vsGamesComparison = _data["vsGamesComparison"] ? PeriodComparison.fromJS(_data["vsGamesComparison"]) : <any>undefined;
            this.singleGamesComparison = _data["singleGamesComparison"] ? PeriodComparison.fromJS(_data["singleGamesComparison"]) : <any>undefined;
            this.dailyChallengeComparison = _data["dailyChallengeComparison"] ? PeriodComparison.fromJS(_data["dailyChallengeComparison"]) : <any>undefined;
            this.vsBotComparison = _data["vsBotComparison"] ? PeriodComparison.fromJS(_data["vsBotComparison"]) : <any>undefined;
            this.vsGamesCompletedComparison = _data["vsGamesCompletedComparison"] ? PeriodComparison.fromJS(_data["vsGamesCompletedComparison"]) : <any>undefined;
            this.singleGamesCompletedComparison = _data["singleGamesCompletedComparison"] ? PeriodComparison.fromJS(_data["singleGamesCompletedComparison"]) : <any>undefined;
            this.vsBotCompletedComparison = _data["vsBotCompletedComparison"] ? PeriodComparison.fromJS(_data["vsBotCompletedComparison"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameHistoryCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameHistoryCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.dataPoints)) {
            data["dataPoints"] = [];
            for (let item of this.dataPoints)
                data["dataPoints"].push(item.toJSON());
        }
        data["totalGames"] = this.totalGames;
        data["vsGamesComparison"] = this.vsGamesComparison ? this.vsGamesComparison.toJSON() : <any>undefined;
        data["singleGamesComparison"] = this.singleGamesComparison ? this.singleGamesComparison.toJSON() : <any>undefined;
        data["dailyChallengeComparison"] = this.dailyChallengeComparison ? this.dailyChallengeComparison.toJSON() : <any>undefined;
        data["vsBotComparison"] = this.vsBotComparison ? this.vsBotComparison.toJSON() : <any>undefined;
        data["vsGamesCompletedComparison"] = this.vsGamesCompletedComparison ? this.vsGamesCompletedComparison.toJSON() : <any>undefined;
        data["singleGamesCompletedComparison"] = this.singleGamesCompletedComparison ? this.singleGamesCompletedComparison.toJSON() : <any>undefined;
        data["vsBotCompletedComparison"] = this.vsBotCompletedComparison ? this.vsBotCompletedComparison.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetGameHistoryCommandResponse {
        const json = this.toJSON();
        let result = new GetGameHistoryCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetGameHistoryCommandResponse {
    success?: boolean;
    dataPoints?: IGameHistoryDataPoint[] | undefined;
    totalGames?: number;
    vsGamesComparison?: IPeriodComparison | undefined;
    singleGamesComparison?: IPeriodComparison | undefined;
    dailyChallengeComparison?: IPeriodComparison | undefined;
    vsBotComparison?: IPeriodComparison | undefined;
    vsGamesCompletedComparison?: IPeriodComparison | undefined;
    singleGamesCompletedComparison?: IPeriodComparison | undefined;
    vsBotCompletedComparison?: IPeriodComparison | undefined;
}

export class TopPerformerInfo implements ITopPerformerInfo {
    userId?: string | undefined;
    username?: string | undefined;
    mode?: string | undefined;
    wins?: number;
    icon?: number | undefined;

    constructor(data?: ITopPerformerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.mode = _data["mode"];
            this.wins = _data["wins"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): TopPerformerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TopPerformerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["mode"] = this.mode;
        data["wins"] = this.wins;
        data["icon"] = this.icon;
        return data;
    }

    clone(): TopPerformerInfo {
        const json = this.toJSON();
        let result = new TopPerformerInfo();
        result.init(json);
        return result;
    }
}

export interface ITopPerformerInfo {
    userId?: string | undefined;
    username?: string | undefined;
    mode?: string | undefined;
    wins?: number;
    icon?: number | undefined;
}

export class GetTopPerformersCommandResponse implements IGetTopPerformersCommandResponse {
    success?: boolean;
    vsModeTop?: TopPerformerInfo | undefined;
    dailyChallengeTop?: TopPerformerInfo | undefined;
    singleModeTop?: TopPerformerInfo | undefined;
    botModeTop?: TopPerformerInfo | undefined;

    constructor(data?: IGetTopPerformersCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.vsModeTop = data.vsModeTop && !(<any>data.vsModeTop).toJSON ? new TopPerformerInfo(data.vsModeTop) : <TopPerformerInfo>this.vsModeTop;
            this.dailyChallengeTop = data.dailyChallengeTop && !(<any>data.dailyChallengeTop).toJSON ? new TopPerformerInfo(data.dailyChallengeTop) : <TopPerformerInfo>this.dailyChallengeTop;
            this.singleModeTop = data.singleModeTop && !(<any>data.singleModeTop).toJSON ? new TopPerformerInfo(data.singleModeTop) : <TopPerformerInfo>this.singleModeTop;
            this.botModeTop = data.botModeTop && !(<any>data.botModeTop).toJSON ? new TopPerformerInfo(data.botModeTop) : <TopPerformerInfo>this.botModeTop;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.vsModeTop = _data["vsModeTop"] ? TopPerformerInfo.fromJS(_data["vsModeTop"]) : <any>undefined;
            this.dailyChallengeTop = _data["dailyChallengeTop"] ? TopPerformerInfo.fromJS(_data["dailyChallengeTop"]) : <any>undefined;
            this.singleModeTop = _data["singleModeTop"] ? TopPerformerInfo.fromJS(_data["singleModeTop"]) : <any>undefined;
            this.botModeTop = _data["botModeTop"] ? TopPerformerInfo.fromJS(_data["botModeTop"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTopPerformersCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopPerformersCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["vsModeTop"] = this.vsModeTop ? this.vsModeTop.toJSON() : <any>undefined;
        data["dailyChallengeTop"] = this.dailyChallengeTop ? this.dailyChallengeTop.toJSON() : <any>undefined;
        data["singleModeTop"] = this.singleModeTop ? this.singleModeTop.toJSON() : <any>undefined;
        data["botModeTop"] = this.botModeTop ? this.botModeTop.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetTopPerformersCommandResponse {
        const json = this.toJSON();
        let result = new GetTopPerformersCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetTopPerformersCommandResponse {
    success?: boolean;
    vsModeTop?: ITopPerformerInfo | undefined;
    dailyChallengeTop?: ITopPerformerInfo | undefined;
    singleModeTop?: ITopPerformerInfo | undefined;
    botModeTop?: ITopPerformerInfo | undefined;
}

export class UpdateTranslationDto implements IUpdateTranslationDto {
    id?: string;
    locale?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUpdateTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locale = _data["locale"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locale"] = this.locale;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }

    clone(): UpdateTranslationDto {
        const json = this.toJSON();
        let result = new UpdateTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTranslationDto {
    id?: string;
    locale?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
}

export class SpecialPromotionDto implements ISpecialPromotionDto {
    id?: string;
    description?: string | undefined;
    htmlDescription?: string | undefined;

    constructor(data?: ISpecialPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.htmlDescription = _data["htmlDescription"];
        }
    }

    static fromJS(data: any): SpecialPromotionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialPromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["htmlDescription"] = this.htmlDescription;
        return data;
    }

    clone(): SpecialPromotionDto {
        const json = this.toJSON();
        let result = new SpecialPromotionDto();
        result.init(json);
        return result;
    }
}

export interface ISpecialPromotionDto {
    id?: string;
    description?: string | undefined;
    htmlDescription?: string | undefined;
}

export enum Operations {
    Add_User = "Add User",
    Add_Role = "Add Role",
    Update_Users = "Update Users",
    Update_Player_Info = "Update Player Info",
    Update_Player_Game = "Update Player Game",
    Update_Player_Ranking = "Update Player Ranking",
    Update_Role = "Update Role",
    Access_Dashboard = "Access Dashboard",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}